/* eslint-disable import/order */
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';

import { projectCreatePermissionsResource } from '@jira/router-resources__project-permissions/src/projectCreatePermissionsResource.tsx';
import { polarisUnlicensedRoute } from '@jira/router-routes__polaris-routes/src/polarisUnlicensedRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import UnlicensedPage, { LazyUnlicensedPage } from './ui/unlicensed/index.tsx';

export const polarisUnlicensedRouteEntry: Route = createEntry(polarisUnlicensedRoute, () => ({
	isStrictModeEnabled: false,
	group: 'polaris',
	// eslint-disable-next-line no-restricted-syntax
	component: UnlicensedPage,
	layout: globalLayout,
	canTransitionIn: () => true,
	resources: [...getNavigationResources(), projectCreatePermissionsResource],
	forPaint: [LazyAtlassianNavigation, LazyUnlicensedPage],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
